import React from 'react';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';   // ← один импорт
import { InstagramCarousel } from '../components/InstagramCarousel';
import '../styles/Home.css';


/* ----------------- Стили для письма благодарности ----------------- */
const GratitudeWrapper = styled.section`
  padding: 1.5rem 9rem;
  text-align: center;
  box-sizing: border-box;
  color: #000;
  font-family: 'AnybodyMedium', sans-serif;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;
const GlobalStyles = createGlobalStyle`
  /* Google Fonts variable: вес-диапазон 100-900  */
  @import url('https://fonts.googleapis.com/css2?family=Anybody:wght@100..900&display=swap');

  /* базовый шрифт всего тела страницы */
  body{font-family:'Anybody',sans-serif;}
`;

const GratitudeText = styled.p`
  font-size: 18.1px;
  font-weight: 600;
  line-height: 24.44px;
  margin: 0 0 1rem;
  word-wrap: break-word;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 19px;
  }
`;

const GratitudeTitle = styled.p`
  font-size: 32px;
  font-weight: 800;
  line-height: 43.2px;
  margin: 0 0 1.5rem;
  word-wrap: break-word;

  @media (max-width: 480px) {
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 1rem;
  }
`;

/* ----------------- Футер ----------------- */
/* ─── в Home.js, сразу после остальных styled-components ─── */
const FooterBar = styled.footer`
  background:#000;
  padding:clamp(2rem,4vh,3rem) 0;
  text-align:center;

  h1{
    color:#fff;
    font-family:'Anybody',sans-serif;   /* ← тот же шрифт */
    font-weight:900;                   /* жирный вес */
    font-size:clamp(2.6rem,8vw,8rem);
    margin:0;
    line-height:1;
  }
`;


/* ----------------------------- Home ----------------------------- */
export const Home = () => {
  /* ---------- карточки ---------- */
  const posters = [
    {
      id: 2,
      src: '/assets/riffmag-2.jpg',
      alt: 'Article 2',
      title: 'RICHARD BUTLER WELCOMES US INTO HIS BRAIN',
      topic: 'Fashion/Music',
      hoverColor: 'rgba(164, 177, 95, 0.85)',
    },
    {
      id: 3,
      src: '/assets/nightoutmain.png',
      alt: 'Article 3',
      title: 'A SMASHING NIGHT OUT',
      topic: 'Fashion/Music',
      hoverColor: 'rgba(150, 150, 150, 0.85)',
    },
    {
      id: 4,
      src: '/assets/image copy 2.png',
      alt: 'Article 4',
      title: 'MEET AURORA AND ALEA',
      topic: 'FASHION',
      hoverColor: 'rgba(115, 130, 146, 0.85)',
    },
    {
      id: 5,
      src: '/assets/epitaphmain.png',
      alt: 'Article 5',
      title: 'EPITAPH',
      topic: 'FASHION/MUSIC',
      hoverColor: 'rgba(26, 26, 9, 0.85)',
    },
    {
      id: 6,
      src: '/assets/vitruta1.png',
      alt: 'Article 6',
      title: 'CAN I HELP YOU? YEAH, WHAT’S THIS TRACK?',
      topic: 'FASHION/MUSIC',
      hoverColor: 'rgba(26, 26, 9, 0.85)',
    },
    {
      id:7,
      src: '/assets/fashionweek.png',
      alt: 'Article 7',
      title: 'THE SOUNDS OF LFW AW25',
      topic: 'FASHION/MUSIC',
      hoverColor: 'rgba(26, 26, 9, 0.85)',
    },
    {
      id:8,
      src: '/assets/robertmain.png',
      alt: 'Article 8',
      title: 'THE UNSUNG SONG OF A CRAFTSMAN',
      topic: 'FASHION',
      hoverColor: 'rgba(26, 26, 9, 0.85)',
    },
    {
      id:9,
      src: '/assets/gilesmain.png',
      alt: 'Article 8',
      title: 'QUICKFIRE QUESTIONS WITH: GILES DEACON',
      topic: 'FASHION',
      hoverColor: 'rgba(26, 26, 9, 0.85)',
    },
    {
      id:10,
      src: '/assets/sanchezposter.png',
      alt: 'Article 8',
      title: 'FRÉDÉRIC SANCHEZ: TUNING THE RUNWAY',
      topic: 'FASHION/MUSIC',
      hoverColor: 'rgba(26, 26, 9, 0.85)',
    },
  ];

  /* ---------- колонки ---------- */
  const columns = [
    posters.filter(p => [2, 8].includes(p.id)),          // 2 ⬇ 8
    posters.filter(p => [3, 6].includes(p.id)),          // 3 ⬇ 6  (чтобы не пустовала колонка)
    posters.filter(p => [4, 7, 10].includes(p.id)),          // 4 ⬇ 9
    posters.filter(p => [5, 9].includes(p.id)),      // 5 ⬇ 7 ⬇ 10
  ];
  

  return (
    <div className="home-wrapper">
      <div className="home-content">
        {/* hero-video */}
        <div className="video-wrapper">
          <div className="video-container">
            <video src="/assets/video.mp4" autoPlay muted loop playsInline />
          </div>
        </div>

        {/* статьи */}
        <div className="articles-grid">
          {columns.map((col, colIndex) => (
            <div key={colIndex} className="column">
              {col.map(poster => (
                <Link
                  key={poster.id}
                  to={`/articles/${poster.id}`}
                  className="article-link"
                >
                  <div
                    className="article-container"
                    style={{ '--hover-bg': poster.hoverColor }}
                  >
                    <img
                      src={poster.src}
                      alt={poster.alt}
                      className="article-poster"
                    />
                    <div className="article-overlay">
                      <h2 className="overlay-title">{poster.title}</h2>
                      <div className="overlay-bottom">
                        <span className="overlay-topic">{poster.topic}</span>
                        <span className="overlay-readmore">Read more</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ))}
        </div>

        {/* Spotify-плейлисты */}
        <section className="spotify-playlists">
          <h2 className="spotify-heading">
            KEEP&nbsp;THE&nbsp;VIBES&nbsp;GOING.&nbsp;LISTEN&nbsp;NOW:
          </h2>

          <iframe
            src="https://open.spotify.com/embed/playlist/1IIztyuBXHTQ2GpIj5wGBK?utm_source=generator"
            width="100%"
            height="352"
            loading="lazy"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            title="RIFF playlist 1"
            style={{ borderRadius: '12px', marginBottom: '0.75rem' }}
          />
          <iframe
            src="https://open.spotify.com/embed/playlist/1tF7k6ii6JENItd3j6D3qb?utm_source=generator"
            width="100%"
            height="352"
            loading="lazy"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            title="RIFF playlist 2"
            style={{ borderRadius: '12px', marginBottom: '0.75rem' }}
          />
        </section>

        {/* Письмо благодарности */}
        <GratitudeWrapper>
          <GratitudeTitle>
            A THANK YOU TO EVERYONE WHO MADE RIFF POSSIBLE
          </GratitudeTitle>
          <GratitudeText>
            I would like to extend immense gratitude to each and every collaborator who came together to make RIFF Magazine a reality. I would like to thank Lawrence Atkin for his remarkable photographic expertise, which has consistently elevated our visual storytelling. David Lammond, for his keen eye and innovative styling on both of our shoots. Equally, I would like to thank Sasha Mamedova for being our makeup artist extraordinaire, and to our models Clementine Mealor-Pritchard, Hannah Hornsby, Ilona Delendik, and Elyssa Saville for their unwavering beauty and talent.
          </GratitudeText>
          <GratitudeText>
          Separately, RIFF Magazine would like to thank our interviewees: Giles Deacon, Jean Louie Castillo, Kid Brunswick, Kieran Feechan and Domenico Di Paolo, Martin Green, Can Aksan, Ulya Soley,  Frédéric Sanchez, and Robert Mercier for taking the time to indulge in your work, your insights have truly brought this magazine to life. And finally to vitruta, the company that hosted a shoot and our launch event within their spaces, without your support, RIFF wouldn't stand as it is today, thank you.
          </GratitudeText>
          <GratitudeText>
            Finally, I would like to extend my deepest thanks to Illia Putintsev, who put RIFF Magazine on the screen. Our digital producer and coder of our popular AI-integrated system. If it weren’t for you and your talent, RIFF would be confined only to my imagination. Thank you for making my thoughts a reality.
          </GratitudeText>
        </GratitudeWrapper>

        {/* Instagram-карусель */}
        <InstagramCarousel />
      </div>

      {/* футер */}
{/* футер */}
<FooterBar>
  <h1>RIFF&nbsp;MAGAZINE</h1>
</FooterBar>

    </div>
  );
};
